module.exports = __webpack_public_path__ + "static/media/harcourt-architects.b498941e.png";